import React, { Component } from "react";
import Flickity from 'flickity'
import "./PropertyDetails.css";
import "../../node_modules/flickity/dist/flickity.css";
require('flickity-imagesloaded');

class PropertyDetails extends Component {
  constructor(props) {
    super(props);

    const detailName = props.match.params.slug;
    const content = props.content;

    let property;
    let catIcon;
    content.forEach(element => {
      element.subItems &&
        element.subItems.forEach(item => {
          item.items &&
            item.items.forEach(prop => {
              if (prop.link.endsWith("/" + detailName)) {
                property = prop;
                catIcon = element.icon;
              }
            });
        });
    });

    this.state = {
      property: property,
      catIcon: catIcon,
    };
  }

  getGoogleMaps() {
    // If we haven't already defined the promise, define it
    if (!this.googleMapsPromise) {
      this.googleMapsPromise = new Promise((resolve) => {
        // Add a global handler for when the API finishes loading
        window.resolveGoogleMapsPromise = () => {
          // Resolve the promise
          // eslint-disable-next-line
          resolve(google);

          // Tidy up
          delete window.resolveGoogleMapsPromise;
        };

        // Load the Google Maps API
        const script = document.createElement("script");
        const API = 'AIzaSyD6t5zKoRfHeAjK3ULHgfJmR5F8nyKEgvY';
        script.src = `https://maps.googleapis.com/maps/api/js?key=${API}&callback=resolveGoogleMapsPromise`;
        script.async = true;
        document.body.appendChild(script);
      });
    }

    // Return a promise for the Google Maps API
    return this.googleMapsPromise;
  }

  componentWillMount() {
    // Start Google Maps API loading since we know we'll soon need it
    this.getGoogleMaps();
  }

  componentDidMount() {
    new Flickity( '.carousel', {
      prevNextButtons: false,
      imagesLoaded: true
    })

    this.getGoogleMaps().then((google) => {
      let location = {lat: this.state.property.lat, lng: this.state.property.long};
      // eslint-disable-next-line
      let map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: this.state.property.lat, lng: this.state.property.long},
        zoom: 14,
        styles: [ { "elementType": "geometry", "stylers": [ { "color": "#eeeeee" } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "elementType": "labels.text.fill", "stylers": [ { "color": "#5b5b5b" } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [ { "color": "#bdbdbd" } ] }, { "featureType": "administrative.neighborhood", "elementType": "labels", "stylers": [ { "color": "#bcbcbc" }, { "visibility": "on" } ] }, { "featureType": "administrative.neighborhood", "elementType": "labels.text", "stylers": [ { "visibility": "on" } ] }, { "featureType": "administrative.neighborhood", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#eeeeee" } ] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#d4d4d4" } ] }, { "featureType": "poi.park", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.park", "elementType": "labels.text.stroke", "stylers": [ { "color": "#fafafa" }, { "visibility": "off" }, { "weight": 2.5 } ] }, { "featureType": "road", "elementType": "geometry", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "visibility": "on" } ] }, { "featureType": "road", "elementType": "geometry.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" }, { "visibility": "on" }, { "weight": 1 } ] }, { "featureType": "road.arterial", "elementType": "labels.text.stroke", "stylers": [ { "color": "#6e6e6e" }, { "visibility": "off" }, { "weight": 0.5 } ] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [ { "color": "#dadada" } ] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [ { "color": "#616161" } ] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [ { "color": "#afafaf" } ] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [ { "color": "#e5e5e5" } ] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [ { "color": "#eeeeee" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#8f8f8f" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#fcfcfc" } ] } ],
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        draggable: false,
        panControl: false,
      });
      // eslint-disable-next-line
      var marker = new google.maps.Marker({
        position: location,
        map: map,
        icon: window.location.origin + '/images/marker.svg',
        title: this.state.property.name
      });
    });
  }
  render() {
    let property = this.state.property;
    const {catIcon} = this.state;

    let carouselItems = []
    property.gallery.forEach(item => {
      carouselItems.push(<div className="carousel-cell">
        <img src={item} alt="" />
        </div>);
    })

    let keys = Object.keys(property.details);
    keys = keys.filter((key)=>key!=="Location")
                .filter((key)=>!(key==="URL"&&property.leasing));


    return (
      <div className="property-details">
        <div className="carousel-container">
          <div className="carousel">
            {carouselItems}
          </div>
          <div className="dots"></div>
        </div>
        <div className="container">
          <div className="row pt-3 justify-content-between">
            <div className="col">
              <div className="title">{property.name}</div>
              <div className="subtitle">{property.details.Location}</div>
            </div>
          </div>
          <div className="row justify-content-between">
            <div className="col-md-6">
              <div className="description">
                {property.description.split("\n").map((item, i) => (
                  <p key={i}>{item}</p>
                ))}
              </div>
            </div>
            <div className="col-md-5">
              <div className="detail-heading d-flex align-items-end">
                <img src={catIcon} alt="category icon" />
                  Property Details
              </div>
              <div className="row details">
                
                {property.details &&
                 keys.map((key, index) => (
                    <div key={index} className="col-sm-6 mt-4">
                      {key === "URL"  ? (
                        <React.Fragment>
                        <div className="detail-item-heading">
                          Website</div>
                        <a
                          className="detail-item-data"
                          href={property.details["URL"].link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {property.details["URL"].text}
                        </a>
                        </React.Fragment>
                      ) : (
                       
                        <React.Fragment>
                          <div className="detail-item-heading">{key}</div>
                          <div className="detail-item-data">
                            {property.details[key]}
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                  ))}
                  
                </div>
                {property.leasing&&<div className="leasing-btn mt-5">
                  <a href={property.details["URL"].link} class="btn btn-dark" role="button" target="_blank" rel="noopener noreferrer">Leasing Now</a>
                </div>}
            </div>
          </div>
        </div>
        <div id="map">
        </div>
      </div>
    );
  }
}

export default PropertyDetails;
